(function (Drupal) {
  'use strict';

  Drupal.behaviors.backToTop = {
    attach: function (context, settings) {
      // Only run once on the body
      if (context !== document) {
        return;
      }

      // Create back to top button if it doesn't exist
      if (!document.getElementById('back-to-top')) {
        var backToTopBtn = document.createElement('button');
        backToTopBtn.id = 'back-to-top';
        backToTopBtn.className = 'back-to-top-btn';
        backToTopBtn.setAttribute('aria-label', 'Back to top');
        backToTopBtn.innerHTML = '<span class="sr-only">Back to top</span>';
        document.body.appendChild(backToTopBtn);
      }

      var backToTopButton = document.getElementById('back-to-top');

      // Remove existing event listeners to prevent duplicates
      if (window.backToTopScrollHandler) {
        window.removeEventListener('scroll', window.backToTopScrollHandler);
      }
      if (window.backToTopClickHandler) {
        backToTopButton.removeEventListener('click', window.backToTopClickHandler);
      }

      // Show/hide button based on scroll position
      window.backToTopScrollHandler = function () {
        if (window.pageYOffset > 300) {
          backToTopButton.classList.add('visible');
        } else {
          backToTopButton.classList.remove('visible');
        }
      };

      // Smooth scroll to top
      window.backToTopClickHandler = function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };

      // Add event listeners
      window.addEventListener('scroll', window.backToTopScrollHandler);
      backToTopButton.addEventListener('click', window.backToTopClickHandler);
    }
  };

})(Drupal);
